import { CHECKLIST_LABELS_RU } from '@carcheck/shared';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import ru from './locales/ru.json';

/**
 * Admin i18n bootstrap. Mirrors the mobile init at
 * `packages/mobile/src/i18n/index.ts` (LOCK 9). v1 ships RU only; future
 * BY / EN locales drop into `locales/<code>.json` and register here.
 *
 * Imported for side-effects from `App.tsx` so i18next is initialised
 * before any screen mounts.
 *
 * AUT-429 — checklist step titles come from the shared RU label bundle
 * (`CHECKLIST_LABELS_RU`, decision D1: one copy for mobile, web and admin)
 * and are merged in under `checklist.step.<key>.title` (+ the tolerant-read
 * `checklist.fallback.step`). They are NOT copied into `ru.json`; screens
 * still resolve them through `t()` (rule 11).
 */
const checklistRu = {
  step: Object.fromEntries(
    Object.entries(CHECKLIST_LABELS_RU.steps).map(([key, label]) => [key, { title: label.title }]),
  ),
  fallback: { step: CHECKLIST_LABELS_RU.fallback.step },
};

export const i18nResources = {
  // `checklist` is the shared bundle's namespace — ru.json must not define one.
  ru: { translation: { ...ru, checklist: checklistRu } },
} as const;

export type AdminLocale = keyof typeof i18nResources;

export const DEFAULT_LOCALE: AdminLocale = 'ru';

// `i18next.use(...)` is the documented chaining API — the rule mistakes
// the method for the named `use` export.
// eslint-disable-next-line import/no-named-as-default-member
void i18next.use(initReactI18next).init({
  resources: i18nResources,
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  interpolation: { escapeValue: false },
  returnNull: false,
});

export default i18next;
